import UserPreferences from 'uScope/js/extensions/user-config/UserPreferences';
import app from '../../public-api';

app.plugins.register({
  name: 'us:user-config',

  extends: 'uScope',

  dependencies: ['pi:platform-api'],

  factory (uScope, api) {
    const service = new UserPreferences(uScope, api);

    uScope.events.on('uScope:reset', service.reset);

    service.init();
    service.load();

    return service;
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/user-config/index.js